import { useNavigate } from 'react-router-dom'
import { shallow } from 'zustand/shallow'

import { useReportStore } from '@/modules/report/useReportsStore'
import { Layout } from '@/modules/shared/layouts/layout'

import { SearchFormReportPeriod } from '../search-form-report-period.component'
import { ChartSalesByClientReport } from './chart-sales-by-client'
import ListSalesByClientReport from './list-sales-by-client'

export function ReportSalesByClient() {
  const navigate = useNavigate()

  const { loading, jsonSalesByClient } = useReportStore(
    (state) => ({
      loading: state.loading,
      jsonSalesByClient: state.jsonSalesByClient,
    }),
    shallow,
  )

  const handleBackPage = () => {
    navigate('/relatorios')
  }

  return (
    <Layout hasSellerFilter
      pageTitle="Relatório - Vendas x Cliente"
      handleGoBack={handleBackPage}
    >
      <SearchFormReportPeriod reportType="Client" />

      {!loading && !!jsonSalesByClient && (
        <div className="space-y-2 mt-2">
          <ChartSalesByClientReport />
          <ListSalesByClientReport />
        </div>
      )}
    </Layout>
  )
}
